import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { LanguageProvider } from './contexts/LanguageContext';
import { SiteHeader } from './components/SiteHeader';
import { SiteFooter } from './components/SiteFooter';
import { Home } from './pages/Home';
import { Portfolio } from './pages/Portfolio';
export function App() {
  return <LanguageProvider data-id="element-0" data-mp="3f8ezjl48lvuq">
      <BrowserRouter data-id="element-1" data-mp="2rkx49flrkfn0">
        <div className="flex min-h-screen w-full flex-col bg-blush-100" data-id="element-2" data-mp="2rkdsyhqmcphy">
          <SiteHeader data-id="element-3" data-mp="2mluairb8hvuc" />
          <main className="flex-1" data-id="element-4" data-mp="2mmcbg18ucy8l">
            <Routes data-id="element-5" data-mp="2mndr6j0sy8wn">
              <Route path="/" element={<Home data-id="element-7" data-mp="31agoopp4khjz" />} data-id="element-6" data-mp="2mjzmh44o1nm1" />
              <Route path="/portfolio" element={<Portfolio data-id="element-9" data-mp="31c1igd3m7wgs" />} data-id="element-8" data-mp="31bs1tg4gn1nr" />
            </Routes>
          </main>
          <SiteFooter data-id="element-10" data-mp="2wiywaq163pam" />
        </div>
      </BrowserRouter>
    </LanguageProvider>;
}